/** Live Feed API service. */

import { apiClient } from '../client';
import { API_ENDPOINTS } from '../endpoints';
import type { LiveFeedResponse } from '@/types/responses';
import { withDedupe } from '@/utils/requestDedupe';

let liveFeedEtag: string | undefined;

/** Clear ETag so the next fetch is unconditional (e.g. manual Refresh). */
export function resetLiveFeedEtag(): void {
  liveFeedEtag = undefined;
}

/**
 * Fetch live feed JSON. Returns null on 304 Not Modified (unchanged body).
 */
export async function fetchLiveFeedData(): Promise<LiveFeedResponse | null> {
  return withDedupe('live_feed:v1:default', async () => {
    try {
      const r = await apiClient.getWithETag<LiveFeedResponse>(API_ENDPOINTS.liveFeed, liveFeedEtag);
      if (r.notModified) {
        return null;
      }
      if (r.etag) {
        liveFeedEtag = r.etag;
      }
      return r.data;
    } catch (error) {
      console.error('Error fetching live feed data:', error);
      throw error;
    }
  });
}

